import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import * as introJs from 'intro.js';
import { AppHttpInterceptor } from '../shared/utilities/intercept';
import { UserService } from './services';
@NgModule({
  providers: [UserService],

  imports: [CommonModule],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error('You should import core module only in the root module');
    }
  }
}
